import { IndeterminateProgressCircle } from '@sunwebgroup/uds-ui/IndeterminateProgressCircle'
import { useIntl } from '@/intl'
import styles from './AuthLoading.module.css'

export function AuthLoading() {
  const intl = useIntl()

  return (
    <div role="status" className={styles.loader}>
      <IndeterminateProgressCircle size={32} />
      <span className={styles.loadingLabel}>{intl.formatMessage({ id: 'auth_loading_label' })}</span>
    </div>
  )
}
